<div style="scroll-behavior: smooth;">
  <div class="row">
    <div class="col">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col">
              <app-data-filter-group>
                @if (currentUserType.userTypeNumber === 0) {
                  <app-data-filter-select label="{{'statements.cashflow.clients' | translate}}"
                    [(model)]="filters.clientId" [options]="clientOptions"
                    (modelChange)="onClientSelectChange($event)">
                  </app-data-filter-select>
                }
                @if (currentUserType.userTypeNumber !== 2) {
                  <app-data-filter-select-search label="{{'statements.cashflow.rentalPoints' | translate}}"
                    [(model)]="filters.rentalPointAccountId" [options]="rentalPointOptions">
                  </app-data-filter-select-search>
                }
              </app-data-filter-group>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col text-right">
              <div class="btn-group btn-group-sm" role="group">
                <button type="button" class="btn btn-primary"
                        (click)="onApplyButtonClick()">{{'statements.cashflow.apply' | translate}}</button>
                <button type="button" class="btn btn-primary"
                        (click)="onResetButtonClick()">{{'statements.cashflow.reset' | translate}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  @if (!showResultContent && !firstLoading) {
    <div class="row mt-3">
      <div class="col">
        <div class="d-flex justify-content-center">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    </div>
  }
  @if (showResultContent) {
    <kendo-grid [data]="gridData" [group]="groups" [resizable]="true">
      <kendo-grid-column field="rentalPoint" title="{{'statements.cashflow.rentalPoints' | translate}}" [hidden]="true">
        <ng-template kendoGridGroupHeaderTemplate let-value="value">
          <span class="k-label" style="margin-right: 20px">{{ value }}</span>
          <button kendoButton class="btn btn-primary" (click)="openVersionHistoryDialog(value)">{{'versions.showVersionHistory' | translate}}</button>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="deviceId" title="{{'versions.deviceId' | translate}}"></kendo-grid-column>
      <kendo-grid-column field="device" title="{{'versions.device' | translate}}"></kendo-grid-column>
      <kendo-grid-column field="deviceType" title="{{'versions.deviceType' | translate}}"></kendo-grid-column>
      <kendo-grid-column field="installationId" title="{{'versions.installation' | translate}}"></kendo-grid-column>
      <kendo-grid-column field="installedVersion" title="{{'versions.version' | translate}}" [width]="80"></kendo-grid-column>
      <kendo-grid-column field="lastUsedAt" title="{{'versions.lastUsedAt' | translate}}" format="dd/MM/yyyy HH:mm:ss"></kendo-grid-column>
      <kendo-grid-column field="lastUsedType" title="{{'versions.lastUsedType' | translate}}"></kendo-grid-column>
      <kendo-grid-column field="lastUsedContractId" title="{{'orders.ordersUnsuccessfulPayments.contractId' | translate}}"></kendo-grid-column>
    </kendo-grid>
  }
  @if (versionHistoryDialogOpen) {
    <kendo-dialog
      (close)="versionHistoryDialogOpen = false"
      [minWidth]="300"
      [maxWidth]="1000">
      <kendo-dialog-titlebar>
        {{dialogTitle}}
      </kendo-dialog-titlebar>
      <div class="dialog-content">
        <table style="border-collapse: separate; border-spacing: 15px 0;">
          <th>{{'versions.deviceId' | translate}}</th>
          <th>{{'versions.device' | translate}}</th>
          <th>{{'versions.deviceType' | translate}}</th>
          <th>{{'versions.installation' | translate}}</th>
          <th>{{'versions.version' | translate}}</th>
          @for (item of dialogData; track item.id) {
            <tr>
              <td>{{item.deviceId}}</td>
              <td>{{item.device}}</td>
              <td>{{item.deviceType}}</td>
              <td>{{item.installation}}</td>
              <td>{{item.androidVersion}}</td>
            </tr>
          }
        </table>
      </div>
    </kendo-dialog>
  }
</div>
